import classnames from "classnames";
import { IFeatureGroup } from "@geo/js";
import * as React from "react";
import { useEffect, useState } from "react";
import { FeatureList } from "./FeatureList";
import "./FeatureGroup.scss";

export const FeatureGroup = ({ featureGroup }: { featureGroup: IFeatureGroup }): JSX.Element => {
    const [expanded, setExpanded] = useState<boolean>(
        featureGroup.expanded !== undefined ? featureGroup.expanded : featureGroup.features.length <= 5
    );

    useEffect(() => {
        featureGroup &&
            featureGroup.sortGroup !== false &&
            (featureGroup.features = sortFeatures(featureGroup.features));
    }, [featureGroup]);

    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <div
                className={classnames("search-result-layer", expanded ? "expanded" : "collapsed")}
                onClick={toggleExpand}
            >
                <div className="feature-group-label">{featureGroup.label}</div>
                <div className="feature-group-length">{featureGroup.features.length}</div>
                <div className={classnames("icon-geolite-chevron-down", { expanded })} />
            </div>
            <div className={classnames("search-result-features", { none: !expanded })}>
                <FeatureList features={featureGroup.features} id={featureGroup.id} />
            </div>
        </>
    );
};

const sortFeatures = (features: any) => {
    if (features.length === 1) {
        return features;
    }

    return features.sort((a: any, b: any) => {
        const valueA = a.label;
        const valueB = b.label;

        if (valueA === undefined) {
            // empty values are sorted to the back
            return 1;
        }
        if (valueB === undefined) {
            return -1;
        }

        if (isString(valueA)) {
            return valueA.localeCompare(valueB, "lv", { sensitivity: "accent" });
        }
        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }
        return 0;
    });
};

const isString = (value: any) => {
    return typeof value === "string" || value instanceof String;
};
